
function addToDropdownList (l, v, fct, sel = false) {
  if (l == null) {
    return
  }

  l.push(
    {
      selected: sel,
      select: fct,
      label: v
    }
  )
}

function highlightDropdownItem (list, selection) {
  if (list == null) {
    return
  }

  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    item.selected = item.label === selection
  }
}

export default {
  dropdown: {
    addItem: addToDropdownList,
    highlightItem: highlightDropdownItem
  }
}
